export const PagePositionType =  {
  unknown: 'PAGE_POSITION_UNKNOWN', // 未知
  lead: 'PAGE_POSITION_LEAD_PRIVATE', // 线索私海
  leadHighSeas: 'PAGE_POSITION_LEAD_PUBLIC', // 线索公海
  potential: 'PAGE_POSITION_POTENTIAL_PRIVATE', // 商机私海
  'potentialHighSeas': 'PAGE_POSITION_POTENTIAL_PUBLIC', // 普通商机公海
  'potentialHighSeas-active': 'PAGE_POSITION_POTENTIAL_PUBLIC', // 活跃商机公海
  'potentialHighSeas-silence': 'PAGE_POSITION_UNKNOWN', // 沉默商机公海
};

// 列表页操作重刷数据
export const LOAD_LEAD_SIGN_STATISTIC_LIST = 'LOAD_LEAD_SIGN_STATISTIC_LIST';

// 详情页操作重刷数据
export const LOAD_LEAD_SIGN_STATISTIC_DETAIL = 'LOAD_LEAD_SIGN_STATISTIC_DETAIL';

// 详情页操作上报
export const LOAD_LEAD_SIGN_STATISTIC_REPORT = 'LOAD_LEAD_SIGN_STATISTIC_REPORT';
